const Footer = {
  footerRoot: null,
  accordionElements: null,
  klaviyoFormWrapper: null,

  initializeElements() {
    this.footerRoot = document?.querySelector('.js-footer');
    this.accordionElements = this.footerRoot?.querySelectorAll(
      '.js-accordion-trigger',
    );
    this.klaviyoFormWrapper = document.querySelector('.klaviyo-form-TMQxfJ');
  },

  initializeEvents() {
    this.initializeElements();
    this.initAccordion();
    this.initKlaviyoFormObserver();
  },

  initAccordion() {
    if (!this.accordionElements) return;

    this.accordionElements.forEach((trigger) => {
      trigger.addEventListener('click', () => this.toggleAccordion(trigger));

      // Add keyboard accessibility
      trigger.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          this.toggleAccordion(trigger);
        }
      });
    });
  },

  toggleAccordion(trigger) {
    const spans = trigger?.querySelectorAll('.js-icon');
    const content = trigger.nextElementSibling;
    const isOpen = trigger.classList.contains('active');

    if (isOpen) {
      this.closeAccordion(trigger, content);
      spans.forEach((span) => span.classList.remove('accordian-open'));
    } else {
      this.accordionElements.forEach((otherTrigger) => {
        if (otherTrigger !== trigger) {
          const otherContent = otherTrigger.nextElementSibling;
          const otherSpans = otherTrigger.querySelectorAll('.js-icon');
          this.closeAccordion(otherTrigger, otherContent);
          otherSpans.forEach((span) => span.classList.remove('accordian-open'));
        }
      });

      this.openAccordion(trigger, content);
      spans.forEach((span) => span.classList.add('accordian-open'));
    }
  },

  openAccordion(trigger, content) {
    trigger.classList.add('active');
    trigger.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    content.classList.remove('hidden');
    content.style.maxHeight = content.scrollHeight + 'px';
  },

  closeAccordion(trigger, content) {
    trigger.classList.remove('active');
    trigger.setAttribute('aria-expanded', 'false');
    content.setAttribute('aria-hidden', 'true');
    content.style.maxHeight = '0px';
    setTimeout(() => {
      content.classList.add('hidden');
    }, 300);
  },

  initKlaviyoFormObserver() {
    if (!this.klaviyoFormWrapper) return;

    const checkConfirmation = this.checkKlaviyoConfirmation.bind(this);

    const observer = new MutationObserver(() => {
      checkConfirmation();
    });

    observer.observe(this.klaviyoFormWrapper, {
      childList: true,
      subtree: true,
    });
  },

  checkKlaviyoConfirmation() {
    const successBlock = [...this.klaviyoFormWrapper.children].find((node) =>
      node.textContent.toLowerCase().includes('thanks'),
    );
    if (successBlock) {
      this.klaviyoFormWrapper.classList.add('hidden');
      document.querySelector('.klaviyo-success')?.classList.remove('hidden');
      document.querySelector('.klaviyo-start')?.classList.add('hidden');
    }
  },
};

export default Footer;
